import { Link } from 'react-router-dom';
import AutoScrollToTop from '../../components/AutoScrollToTop';

const FooterTwo = () => {
   
    return (
        <>
      <section className="footer footer-3 pt-150" id='contact'>
        <div className="">
          <div className="container">
            <div className='row footer-links address'>
              <h5 className="widget-title">Address</h5>

                <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                  <Link to="https://maps.app.goo.gl/gUN8RdMAPZrRVsK56" target='blank'>
                    <ul>
                      <li className='caption'>Headquarter Office Denpasar</li>
                      <li>Jl. Buluh Indah No.56, Pemecutan Kaja, Denpasar, Kota Denpasar, Bali 80111</li>
                    </ul>
                  </Link>
                </div>    
                <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                  <Link to="https://maps.app.goo.gl/JvoFQ5A2qAKCto598" target='blank'>
                    <ul>
                      <li className='caption'>Medan Branch Office</li>
                      <li>Cradle Coworking and Event Space</li>
                      <li>Jl. Iskandar Muda No.127 Medan Petisah - Medan</li>
                    </ul>
                  </Link>
                </div> 
                <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                  <Link to="https://maps.app.goo.gl/RCKywjxQ6zMe1GSK7" target='blank'>
                    <ul>
                      <li className='caption'>Jakarta Branch Office</li>
                      <li>MULA Coworking (CITOS)</li>
                      <li>Jl. TB Simatupang No.17, Cilandak, Jakarta Selatan - Jakarta</li>
                    </ul>
                  </Link>
                </div>     
              <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                <Link to="https://maps.app.goo.gl/6y898y4ZTUoKL2416" target='blank'>
                  <ul>
                    <li className='caption'>Yogyakarta Branch Office</li>
                    <li>Block C5, Ruko Yap SquareJl. C Simanjuntak, Terban, Gondokusuman - Yogyakarta</li>
                  </ul>
                </Link>
              </div>    
              <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                <Link to="https://maps.app.goo.gl/iviMMPmDL2xv9vz57" target='blank'>
                  <ul>
                    <li className='caption'>Makassar Branch Office</li>
                    <li>Bikin Bikin Creative Hub Mall Nipah</li>
                    <li>Jl. Urip Sumoharjo No.23C Panakkukang - Kota Makassar</li>
                  </ul>
                </Link>
              </div> 
              <div className='col-xl-2 col-sm-8 me-auto pb-4'>
                <Link to="https://maps.app.goo.gl/9cR1bZhCH9mMzYE56" target='blank'>
                  <ul>
                    <li className='caption'>Surabaya Branch Office</li>
                    <li>IdeaHub Coworking Space</li>
                    <li>Voza Tower, Jl. Mayjen HR. Muhammad No.31, Putat Gede, Surabaya-Jawa Timur</li>
                  </ul>
                </Link>
              </div>     
            </div>
          </div>
        </div>

        <div className="footer-btm">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-xl-6 col-sm-12 col-lg-6">
                <p className="mb-0 copyright text-sm-center text-lg-start">© 2025 All rights reserved by IT Team NIEC</p>
              </div>
            </div>
          </div>
        </div>


        
      </section>
        </>
    )
}

export default FooterTwo;